import { outdent } from 'outdent';

const COMPONENT_HMR_PARAMETER = 'component-hmr';
export const COMPONENT_HMR_RE = new RegExp(`[?&]${COMPONENT_HMR_PARAMETER}\\b`);

export const getComponentPathWithHMR = (relativePath: string) =>
  `/${relativePath}?${COMPONENT_HMR_PARAMETER}`;

export const getComponentHMRTemplate = (id: string, root: string) => {
  const originalId = id.replace(COMPONENT_HMR_RE, '').replace(root, '');

  return outdent`
    import { createComponentHmrWrapper } from '@wix/cli-app/internal/component-hmr-wrapper';
    import OriginalComponent from '${originalId}';

    if (import.meta.hot) {
      // We catch HMR updates because otherwise Vite reloads the component as a fallback
      import.meta.hot.accept((_) => {});

      import.meta.hot.accept(
        '${originalId}',
        ({ default: NewComponent }) => {
          // 'createComponentHmrWrapper' sets 'import.meta.hot.data.setComponent'
          // so we can call it here
          import.meta.hot.data.setComponent(NewComponent);
        }
      );
    }

    export default createComponentHmrWrapper(OriginalComponent, import.meta.hot.data);
    export * from '${originalId}';
  `;
};
